import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import lang from '../lang'

var timer = null

export default class extends React.Component {
  state = {
    day: '0',
    hour: '0',
    minute: '0',
    second: '0',
  }

  constructor(props) {
    super(props)
  }

  countDown = (times) => {
    if (timer == null && times > 0) {
      timer = setInterval(function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0;//时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24));
          hour = Math.floor(times / (60 * 60)) - (day * 24);
          minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60);
          second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
        }
        if (day <= 9) day = day;
        if (hour <= 9) hour = '0' + hour;
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
        // let daystr = ""
        // if (day > 0) {
        //   daystr = `<span className="white">${day}</span>days`
        // }
        //
        this.setState({ day: day, hour: hour, minute: minute, second: second })
        times--;
      }.bind(this), 1000);
    }
    // if (times <= 0) {
    //   clearInterval(timer);
    // }
  }

  componentDidMount() {
    console.log('componentDidMount')
    // let { remaintime } = this.props
  }

  componentWillReceiveProps(e) {
    console.log('componentWillReceiveProps')
    let { remaintime } = e
    this.countDown(remaintime)
  }

  render() {
    let { lang, remaintime, now } = this.props
    console.log('remaintime', remaintime, now)
    let { day, hour, minute, second } = this.state
    let div = `<div class="time"><div class="white">${day}</div><div class="mao">:</div><div class="white">${hour}</div><div class="mao">:</div><div class="white">${minute}</div><div class="mao">:</div><div class="white">${second}</div></div>`
    return (
      <div className="Countdown">
        <div className="countdiv" dangerouslySetInnerHTML={{ __html: div }}>
        </div>
        <div className="countdiv2">
          <div className="word">{lang.day}</div><div className="word">{lang.hour}</div><div className="word">{lang.min}</div><div className="word">{lang.sec}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/Countdown/index.js